import React, { Component } from 'react';
import { Provider } from 'react-redux';
import './App.css';

import Routes from './routes';
import { store } from './store';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Provider store={store}>
          <Routes />
        </Provider>
      </div>
    );
  }
}

export default App;
